import React from 'react';
import { Navbar } from '../../components';
import EthewareSignUp from '../../components/ethewareSignUp/ethewareSignUp';
import { Footer } from '../../containers';
import './etwSignUpPage.css';

const EtwSignUpPage = () => {
  return (
    <div className='etwsignup__container'>
     <EthewareSignUp />
     <Footer />
    </div>
  )
}

export default EtwSignUpPage
